import { ISanctionsOptions, IStateOptions, SanctionCode, SanctionType } from "../reports.interface";

export const SANCTION_CODE_TO_TYPE: Record<SanctionCode, SanctionType> = {
    'disclaimer': 'WARNING',
    'content-removal': 'CONTENT_REMOVAL',
    'temporary-suspension': 'SUSPENSION',
    'permanent-suspension': 'BAN'
};

export const SANCTION_SEVERITY: Record<SanctionType, number> = {
    'WARNING': 1,
    'CONTENT_REMOVAL': 2,
    'SUSPENSION': 3,
    'BAN': 4
};

export const stateOptions: IStateOptions[] = [
    {
        label: 'Détails',
        value: 'details'
    },
    {
        label: 'Utilisateurs',
        value: 'users'
    },
    {
        label: 'Action',
        value: 'action'
    }
]

export const sanctionsOptions: ISanctionsOptions[] = [
    {
        name: 'Avertissement',
        code: 'disclaimer'
    },
    {
        name: 'Suppression du contenu',
        code: 'content-removal'
    },
    {
        name: 'Suspension temporaire',
        code: 'temporary-suspension'
    },
    {
        name: 'Banissement définitif',
        code: 'permanent-suspension'
    },
]

export type SeverityType = "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | null | undefined;